<template>
  <div ref="schedulerWrap" class="calendar-scheduler-wrap">
    <div class="scheduler-controls flex-row space-end" style="position: relative">
      <button class="btn btn-xs btn-default" v-on:click="toggleWeekStart">{{ toggleWeekStartText }}</button>
      <button class="btn btn-xs btn-default" v-on:click="toggleFirstHour">{{ toggleFirstHourText }}</button>
    </div>
    <div ref="schedulerElement" class="dhx_cal_container" style="width:100%" v-once>
      <div class="scheduler-date-wrap">
        <div class="dhx_cal_date"></div>
      </div>
      <div class="dhx_cal_navline">
        <div class="dhx_cal_prev_button">&nbsp;</div>
        <div class="dhx_cal_next_button">&nbsp;</div>
        <div class="dhx_cal_today_button"></div>
        <div class="dhx_cal_tab" name="day_tab"></div>
        <div class="dhx_cal_tab" name="week_tab" style="left: 90px"></div>
        <div class="dhx_cal_tab" name="month_tab" style="left: 180px"></div>
      </div>
      <div class="dhx_cal_header"></div>
      <div class="dhx_cal_data"></div>
    </div>
  </div>
</template>
 
<script>
import 'dhtmlx-scheduler/codebase/dhtmlxscheduler_material.css'
import 'dhtmlx-scheduler'
// import 'dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_timeline'
import 'dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_container_autoresize'
// import 'dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_tooltip'
import { mapGetters } from 'vuex'
import events from '~/lib/events'
import { guardSchedulerRender, schedulerEventHasDates } from '~/lib/schedulerGuards'

export default {
  data () {
    return {
      originalEvent: null,
      scheduler: null,
      parentNode: null,
      offset: 80,
      hideHours: 9,
      firstHour: 9,
      defaultWeekStart: 5, // Friday
      showNormalWeek: false
    }
  },
  name: 'calendar',
  mixins: [ events ],
  props: ['url', 'shopId', 'locale', 'reloadEvents', 'weekStart', 'initialWeekStart', 'productFilter', 'resourceFilter', 'column'],
  computed: {
    ...mapGetters(['dateFormat', 'timeFormat']),
    defaultDateFormat () {
      switch(this.dateFormat) {
        case 'D.M.YYYY':
          return '%j.%n.%Y'
        case 'M.D.YYYY':
          return '%n.%j.%Y'
        case 'YYYY.MM.DD':
          return '%Y.%n.%j'
        case 'DD-MM-YYYY':
          return '%d-%m-%Y'
        case 'MM-DD-YYYY':
          return '%m-%d-%Y'
        case 'YYYY-MM-DD':
          return '&Y-%m-%d'
        case 'DD/MM/YYYY':
          return '%j/%n/%Y'
        case 'MM/DD/YYYY':
          return '%n/%j/%Y'
        case 'YYYY/MM/DD':
          return '%Y/%n/%j'
        case 'MMM D, YYYY':
          return '%M %j, %Y'
      }
      return '%j.%n.%Y'
    },
    defaultWeekScaleDate () {
      switch (this.dateFormat) {
        case 'D.M.YYYY':
          return '%l %j.%n.'
        case 'M.D.YYYY':
        case 'YYYY.MM.DD':
          return '%l %n.%j.'
        case 'DD-MM-YYYY':
          return '%l %d-%m'
        case 'MM-DD-YYYY':
        case 'YYYY-MM-DD':
          return '%l %m-%d'
        case 'DD/MM/YYYY':
          return '%l %j/%n'
        case 'MM/DD/YYYY':
        case 'YYYY/MM/DD':
          return '%l %n/%j'
        case 'MMM D, YYYY':
          return '%l, %M %j'
      }
      return '%l %j.%n.'
    },
    defaultHourScale () {
      switch (this.timeFormat) {
        case 'H:mm':
          return '%G:%i'
        case 'h:mm A':
          return '%g:%i %A'
        case 'H.mm':
        default:
          return '%G.%i'
      }
    },
    shortLocale () {
      return this.locale.split('_')[0]
    },
    toggleFirstHourText () {
      return this.firstHour === 0 ? this._('Hide start of day') : this._('Show full days')
    },
    toggleWeekStartText () {
      const shortDayNames = [
        this._('Mon'),
        this._('Tue'),
        this._('Wed'),
        this._('Thu'),
        this._('Fri'),
        this._('Sat'),
        this._('Sun'),
      ]
      const offsetWeekStart = (typeof this.weekStart !== 'undefined' ? parseInt(this.weekStart,10) : this.defaultWeekStart) - 1
      const offsetWeekEnd = (offsetWeekStart + 6) % 7
       return this.showNormalWeek ? this._(shortDayNames[offsetWeekStart]) + '-' + this._(shortDayNames[offsetWeekEnd]) : this._('Mon') + '-' + this._('Sun')
    },
    computedWeekStart () {
      return (this.showNormalWeek ? 1 : this.weekStart || this.defaultWeekStart)
    },
    myComponentId () { // Special case: this thingy can be embedded in the product details view
      if (this.column) {
        if (this.column.component && this.column.component.type !== 'Showtimes') {
          return this.column.identifier + '-' + this.column.component.id + '-showtimes'
        }
        return this.column.identifier + '-' + this.column.component.id
      }
      return null
    },
    weekModeStorageKey () {
      if (this.myComponentId) {
        return 'calendar-weekmode-' + this.shopId + '-' + this.myComponentId
      }
      return 'calendar-weekmode-' + this.shopId
    }
  },
  methods: {
    getSchedulerElement () {
      return this.$refs.schedulerElement
    },
    initScheduler (date, mode) {
      this.scheduler.init(this.getSchedulerElement(), date || new Date(), mode || 'week')
    },
    applyWeekStart () {
      let $this = this
      this.scheduler.date.week_start = function (date) {
        var weekStart = $this.computedWeekStart
        var startDay = date.getDay()
        var shift
        if (startDay == 0) {
          shift = 7 - weekStart
        } else {
          shift = startDay - weekStart
        }
        if (shift < 0) {
          shift = 7 + shift
        }
        return this.date_part(this.add(date, -1 * shift, "day"))
      }
    },
    toggleWeekStart () {
      this.showNormalWeek = !this.showNormalWeek
      this.persistWeekModeToStorage()
      this.applyWeekStart()
      this.initScheduler(new Date(), 'week')
    },
    restoreWeekModeFromStorage () {
      try {
        const stored = localStorage.getItem(this.weekModeStorageKey)
        if (stored === null) {
          return false
        }
        this.showNormalWeek = stored === 'true'
        return true
      } catch (e) {
        return false
      }
    },
    persistWeekModeToStorage () {
      try {
        localStorage.setItem(this.weekModeStorageKey, this.showNormalWeek ? 'true' : 'false')
      } catch (e) {}
    },
    applyInitialWeekStart () {
      if (this.initialWeekStart !== 1) {
        this.showNormalWeek = false
      } else {
        this.showNormalWeek = true
      }
    },
    toggleFirstHour () {
      if (this.firstHour === this.hideHours) {
        this.firstHour = 0
      } else {
        this.firstHour = this.hideHours
      }
    },
    reload () {
      this.scheduler._loaded = {};
      this.scheduler.load(this.url, 'json');
    },
    async setLocale () {
      switch (this.locale) {
        case 'fi_FI':
        case 'de_DE':
        case 'it_IT':
        case 'ru_RU':
        case 'sv_SE':
        case 'es_ES':
        case 'fr_FR':
          await import(`../assets/dhtmlx/locale/locale_${this.shortLocale}.js`)
          break
        case 'nb_NO':
          await import(`../assets/dhtmlx/locale/locale_no.js`)
          break
      }
    },
    async init () {
      let $this = this
      await this.setLocale()
      this.scheduler = Scheduler.getSchedulerInstance()
      guardSchedulerRender(this.scheduler)
      /*
      this.scheduler.dhtmlXTooltip.config.className = 'dhtmlXTooltip tooltip'
      this.scheduler.dhtmlXTooltip.config.timeout_to_display = 50
      this.scheduler.dhtmlXTooltip.config.delta_x = 15
      this.scheduler.dhtmlXTooltip.config.delta_y = -20
      */
      this.scheduler.config.fix_tab_position = false
      this.scheduler.config.first_hour = this.firstHour
      this.scheduler.config.details_on_create = true
      this.scheduler.config.details_on_dblclick = true
      this.scheduler.config.xml_date = '%Y-%m-%d %H:%i'
      this.scheduler.config.default_date = this.defaultDateFormat
      this.scheduler.config.hour_date = this.defaultHourScale
      this.scheduler.config.time_step = 15
      this.scheduler.config.container_autoresize = true
      this.applyWeekStart()
      this.scheduler.templates.week_scale_date = function(date) {
        var format = scheduler.date.date_to_str($this.defaultWeekScaleDate)
        return format(date)
      }
      this.scheduler.templates.hour_scale = function(date) {
        var format = scheduler.date.date_to_str($this.defaultHourScale)
        return format(date)
      }
      this.scheduler.templates.event_class = function(start, end, event) {
        var cls = ''
        if (parseInt(event.upcoming)) {
          cls = 'dhx_upcomingshow'
        } 
        if (parseInt(event.hideinternet) && parseInt(event.hidepos)) {
          cls += ' dhx_hideall'
        } else if (parseInt(event.hideinternet)) {
          cls += ' dhx_hideinternet'
        } else if (parseInt(event.hidepos)) {
          cls += ' dhx_hidepos'
        }
        return 'dhx_show ' + cls
      }
      this.scheduler.templates.event_text = function(start, end, event) {
        var btnClass = 'label-'
        var allocation = Math.round((event.resource_reservations / event.resource_capacity) * 100)
        if (allocation < 50) {
          btnClass += 'success'
        } else if (allocation < 75) {
          btnClass += 'warning'
        } else {
          btnClass += 'danger'
        }
        return '<strong class="event-name">' + event.text  + '</strong><span class="event-venue label label-info">' + (event.resource_name ? event.resource_name : '') + '</span>' + (event.resource_capacity ? '<span class="event-capacity label ' + btnClass + '">' + event.resource_reservations  + ' / ' + event.resource_capacity + '</span>' : '')
      }
      this.scheduler.attachEvent('onClick', function(id, e) {
        if(!id) {
          return
        }
        let event = $this.scheduler.getEvent(id)
        if (e.target.classList && e.target.classList.contains('event-capacity')) {
          $this.$emit('capacityClicked', event)
        } else {
          $this.$emit('eventClicked', event, true, $this.deleteHandler)
        }
      })
      this.scheduler.attachEvent('onBeforeEventChanged', function(ev, e, is_new, original) {
        $this.originalEvent = original
        return true
      })
      this.scheduler.attachEvent('onDragEnd', function(id, mode, e) {
        if(!id) {
          return
        }
        var event = $this.scheduler.getEvent(id);
        if (!schedulerEventHasDates(event) || !$this.originalEvent || !$this.originalEvent.start_date) {
          return
        }
        if(event.start_date.getTime() == $this.originalEvent.start_date.getTime() && event.end_date.getTime() == $this.originalEvent.end_date.getTime()) {
          return
        }
        $this.$emit('eventDragged', event, () => {
          if (!event || !$this.originalEvent) {
            return
          }
          event.start_date = $this.originalEvent.start_date
          event.end_date = $this.originalEvent.end_date
          if (event.id) {
            $this.scheduler.updateEvent(event.id)
          }
        })
      })
      this.scheduler.filter_week = function (id, event) {
        if ($this.resourceFilter) {
          if (event.resource_id != $this.resourceFilter) {
            return false
          }
        }
        if ($this.productFilter) {
          if (event.product_id != $this.productFilter) {
            return false
          }
        }
        return true
      }
      this.scheduler.attachEvent('onEventLoading', function (event) {
        return schedulerEventHasDates(event)
      })
      this.scheduler.showLightbox = this.editShow
      this.initScheduler(new Date(), 'week')
      this.scheduler.setLoadMode('month')
      this.reload()
    },
    editShow (id) {
      let event = this.scheduler.getEvent(id)
      this.$emit('eventClicked', event, false, this.deleteHandler)
    },
    deleteHandler (event) {
      let id = event
      if (event && event.id) {
        id = event.id
      }
      this.scheduler.deleteEvent(id)
    },
    saveViewState (view) {
      // @todo
    }
  },
  watch: {
    firstHour (newVal) {
      if (!this.scheduler) {
        return
      }
      this.scheduler.config.first_hour = newVal
      this.scheduler.setCurrentView(this.scheduler.getState().date)
    },
    productFilter () {
      if (!this.scheduler) {
        return
      }
      this.scheduler.updateView()
    },
    resourceFilter () {
      if (!this.scheduler) {
        return
      }
      this.scheduler.updateView()
    }
  },
  async mounted () {
    if (typeof this.weekStart !== 'undefined') {
      this.defaultWeekStart = this.weekStart
    }
    if (!this.restoreWeekModeFromStorage()) {
      this.applyInitialWeekStart()
    }
    await this.init()
    if (!this.events && this.reloadEvents) {
      let events = {}
      for (var i = 0; i < this.reloadEvents.length; i++) {
        let eventType = this.reloadEvents[i]
        events[eventType] = (message) => {
          if (message && message.data && message.shopId === this.shopId) {
            return this.reload()
          }
        }
      }
      events['calendarUpdate'] = (message) => {
        // This is an awful hack that somehow triggers a refresh of the calendar view in the product editor, after the pricing tab has been clicked
        // Potential fix @todo: Switch from Bootstrap's tab switching to native Vue with v-show (or v-if)
        setTimeout(() => {
          this.scheduler.setCurrentView(this.scheduler.getState().date)
        }, 1)
      }
      this.events = events
    }
    this.enableEventBus()
  },
  beforeUnmount () {
    if (this.scheduler) {
      this.scheduler.clearAll()
      if (this.scheduler.destructor) {
        this.scheduler.destructor()
      }
      this.scheduler = null
    }
  }
}
</script>
 
<style type="text/css">
.calendar-scheduler-wrap .scheduler-controls {
  margin-bottom: 6px;
  gap: 4px;
}
/*
.listviewfilter, .timelinefilter, .showtimesfilter {
    display: none;
}

.scheduler-min-calendar-tab {
    padding: 0 5px;
    color: #747473;
    text-decoration: none;
    font-weight: 700;
    font-family: arial;
    font-size: 12px;
    line-height: 30px;
    border: 1px solid #CECECE;
    text-align: center;
    border-radius: 5px;
    background-position-x: 8px;
    background-position-y: 4px;
}

td.dhx_matrix_scell {
    overflow: hidden;
    text-overflow: ellipsis;
}


@media screen and (max-width: 767px) {
  td.dhx_matrix_scell {
      max-width: 100px;
  }
} 

.dhx_cal_container {
    background-color: transparent;
}

.dhx_cal_navline .dhx_cal_date, .dhx_cal_container, .dhx_scale_bar, .dhx_cal_today_button {
    font-family: 'Oxygen', Arial, sans-serif;
}
.dhx_matrix_scell {
    text-align: left;
}
.dhx_today {
    background-color: #E6ED9C;
}
.dhx_weekend {
    background-color: #eeeeee;
}
.dhx_johkuevent, .dhx_johkupaidorderevent {
    background-color: #cddc39;
    border-color: #b2c022;
    color: #616913;
    font-family: 'Oxygen', Arial, sans-serif;
    z-index: 1;
}
.dhx_johkureservationevent {
    border-color: #B0BEC5;
    color: #455A64;
    font-family: 'Oxygen', Arial, sans-serif;
    z-index: 1;
}
.dhx_johkuopenorderevent {
    border-color: #237EBB;
    color: #FFF;
    font-family: 'Oxygen', Arial, sans-serif;
    z-index: 1;
}
.dhx_johkuunpaidorderevent {
    border-color: #E57373;
    color: #380A0A;
    font-family: 'Oxygen', Arial, sans-serif;
    z-index: 1;
}
.dhx_pastevent {
    opacity: 0.75;
}
.dhx_johkuunpaidorderevent.dhx_pastevent, .dhx_johkuunpaidorderevent.dhx_currentevent, .dhx_johkuunpaidorderevent.dhx_upcomingevent {
    background-color: #EF9A9A;
}
.dhx_johkureservationevent.dhx_pastevent, .dhx_johkureservationevent.dhx_currentevent, .dhx_johkureservationevent.dhx_upcomingevent {
    background-color:#CFD8DC;
}
.dhx_johkuevent.dhx_currentevent, .dhx_johkuevent.dhx_pastevent {
    background-color: #cddc39;
}
.dhx_johkuopenorderevent.dhx_pastevent, .dhx_johkuopenorderevent.dhx_currentevent, .dhx_johkuopenorderevent.dhx_upcomingevent {
  background-color: #3499DB;
}
.dhx_upcomingevent {
    opacity: 0.75;
}
.dhx_show > div {
    background-color: #3499DB ! important;
}
.dhx_upcomingshow > div, .dhx_cal_event_line.dhx_upcomingshow {
    background-color: #EF9A9A ! important;
}
.dhx_hideall {
    opacity: 0.5 ! important;
}
.dhx_hideinternet {
    opacity: 0.75 ! important;
}
.dhx_hidepos {
    opacity: 0.75 ! important;
}


.dhx_zoom_in_button {
    background-image: url(../node_modules/dhtmlx-scheduler/codebase/imgs/buttons.png);
    background-position: 0 0;
    cursor: pointer;
}

.dhx_zoom_in_button, .dhx_zoom_out_button {
    color: #454544;
    height: 30px;
    line-height: 30px;
    background: 0 0;
    border: 1px solid #CECECE;
}

.dhx_zoom_in_button, .dhx_zoom_out_button {
    width: 46px;
}

.dhx_zoom_in_button {
    right: 61px;
    -webkit-border-top-left-radius: 5px;
    -webkit-border-bottom-left-radius: 5px;
    -moz-border-radius-topleft: 5px;
    -moz-border-radius-bottomleft: 5px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
}

.dhx_zoom_out_button {
    right: 61px;
    -webkit-border-top-right-radius: 5px;
    -webkit-border-bottom-right-radius: 5px;
    -moz-border-radius-topright: 5px;
    -moz-border-radius-bottomright: 5px;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
}

.worktime {
    background: grey;
    opacity: 0.4;
}
#eventForm hr {
  margin-top: 0px;
  margin-bottom: 5px;
  border-top: 1px solid #e5e5e5;
}

.order_popup_table {
    width: 100%;
    font-size: 11px;
}

.order_popup_count, .order_popup_price {
    text-align: right;
}
.order_popup_more {
    font-style: italic;
}
.fixit {
  position: fixed !important;
  left: inherit !important;
  background-color: #FFF;
}
.not-dhx_cal_header {
  -webkit-transform: translate3d(0, 0, 0);
}
.dhx_cal_header.fixit {
  margin-left: -1px;
  margin-top: -1px;
  border-bottom: 1px solid #CCC;
}
#showtimes .dhx_cal_header.fixit {
  margin-left: 50px;
}
#showtimes.dhx_scheduler_month .dhx_cal_header.fixit {
  margin-left: inherit;
}
.content-wrap, .content-wrap :not(label):not(div):not(table):not(td):not(section):not(header):not(g):not(path):not(rect):not(circle):not(ellipse):not(line):not(polyline):not(polygon):not(text):not(tspan):not(use):not(marker):not(foreignObject) {
  transform: none !important;
}
.bootbox-fullscreen {
  z-index: 2000000001  ! important;
}
.bootbox-fullscreen .modal-dialog {
  width: 98%;
}
*/
</style>